export enum ChannelTypes {
    Chat = 1,
    PhoneCall =2,
    WebSite = 3,
    UserCreated = 4,
    SMS = 5,
    Email = 6
}
